import React from "react";

const Col = ({ children, col = "col-12" }) => {
    return <div className={col}>{children}</div>;
};

export default Col;
